import { z } from 'zod';
export const CONSENT_POLICY_VERSION = '2026-06-13.v1';
export const consentPurposeSchema = z.enum([
    'marketing_email',
    'marketing_push',
    'analytics',
    'health_sync',
    'cycle',
]);
export const consentSurfaceSchema = z.enum([
    'signup',
    'settings_web',
    'settings_mobile',
    'landing_cookie_banner',
    'brevo_webhook',
    'brevo_reconcile',
    'waitlist',
]);
export const consentStateSchema = z.object({
    purpose: consentPurposeSchema,
    granted: z.boolean(),
    updatedAt: z.string().datetime().nullable(),
    surface: consentSurfaceSchema.nullable(),
    policyVersion: z.string(),
});
export const consentsResponseSchema = z.object({
    policyVersion: z.string(),
    consents: z.array(consentStateSchema),
});
export const updateConsentItemSchema = z.object({
    purpose: consentPurposeSchema,
    granted: z.boolean(),
});
export const updateConsentsSchema = z.object({
    consents: z.array(updateConsentItemSchema).min(1),
    surface: consentSurfaceSchema.optional(),
});
export const anonymousConsentResponseSchema = z.object({
    policyVersion: z.string(),
    analytics: consentStateSchema,
});
export const updateAnonymousConsentSchema = z.object({
    analytics: z.boolean(),
    surface: z.literal('landing_cookie_banner').optional(),
});
//# sourceMappingURL=consent.js.map